import React from 'react';

const Background = ( { children } ) =>
{
    return (
        <>
        {children}
        </>
    )
}

export default Background;